import React from 'react'
import type { Season } from '../../../../Context/PlayerProfileContext/PlayerProfileContext'
import { SeasonType } from '../../../../Routing/urls'
import { SeasonTypeItemCon, SeasonTypeOuterCon } from './styles'

type SeasonSelectorProps = {
  seasonType: Season['seasonType']
  disablePostSeason?: boolean
  disableChampSeries?: boolean
  color?: string
  onSelectSeasonType: (seasonType: SeasonType) => void
}

export const SeasonTypeRow: React.FC<React.PropsWithChildren<SeasonSelectorProps>> = ({
  seasonType,
  disablePostSeason,
  disableChampSeries = true,
  onSelectSeasonType,
}) => {
  const onChangeType = (sType: SeasonType) => {
    onSelectSeasonType(sType)
  }

  return (
    <SeasonTypeOuterCon>
      <SeasonTypeItemCon
        active={seasonType === 'regular'}
        onClick={() => onChangeType('regular')}
      >
        Regular
      </SeasonTypeItemCon>
      <SeasonTypeItemCon
        active={seasonType === 'post'}
        disabled={disablePostSeason}
        onClick={() => onChangeType('post')}
      >
        Post
      </SeasonTypeItemCon>
      {!disableChampSeries && (
        <SeasonTypeItemCon
          active={seasonType === 'champseries'}
          disabled={disableChampSeries}
          onClick={() => onChangeType('champseries')}
        >
          Champ Series
        </SeasonTypeItemCon>
      )}
    </SeasonTypeOuterCon>
  )
}
